import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { AbstractView } from '@core/interfaces';
import { ConfirmationDialogPresenter } from './confirmation-dialog.presenter';
import { ConfirmationDialogViewPresenter } from './interfaces';
import { SharedModule } from '@shared/shared.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [
    SharedModule,
    ButtonModule,
    ConfirmDialogModule,
  ],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  providers: [ConfirmationDialogPresenter],
})
export class ConfirmationDialogComponent
  extends AbstractView<ConfirmationDialogPresenter>
  implements ConfirmationDialogViewPresenter, OnInit
{
  @Input({ required: true }) key!: string;
  @Input() header: string = 'Confirmation';
  @Input() icon: string = 'pi pi-exclamation-triangle';
  @Input() message: string = 'Are you sure you want to proceed?';
  @Output() actionAcceptTriggered = new EventEmitter<void>();
  @Output() actionCancelTriggered = new EventEmitter<void>();

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: ConfirmationDialogPresenter
  ) {
    super(messageService, router, store, presenter);
  }

  ngOnInit(): void {
    this.presenter.setView(this);
  }

  onAccept(): void {
    this.presenter.onAccept();
  }

  onCancel(): void {
    this.presenter.onCancel();
  }
}
